module.exports = __webpack_public_path__ + "static/img/why1.7b56abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/why1.jpg
// module id = /mlz
// module chunks = 47